import { useCallback } from 'react';

type UseFlameIsolateSpanParams = {
  isolationEnabled: boolean;
  byId: Map<unknown, unknown>;
  isolatedId: unknown;
  isolate: (id: unknown) => void;
};

/**
 * @internal
 */
export function useFlameIsolateSpan({
  isolationEnabled,
  byId,
  isolatedId,
  isolate,
}: UseFlameIsolateSpanParams): (id: unknown) => void {
  return useCallback(
    (id: unknown) => {
      if (!isolationEnabled) {
        return;
      }
      if (!byId.has(id)) {
        return;
      }
      if (id === isolatedId) {
        return;
      }
      isolate(id);
    },
    [isolationEnabled, byId, isolatedId, isolate],
  );
}
